export const normalizeEmail = (email: string) => email?.toLowerCase?.()?.trim?.();
